module.exports = "/img/_/_/_/assets/images/creeper/battle/common//39.jpg?0c0d6e2bd6f0836f90b317ef96bfd679";